import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { X, Building2, Edit3, Save, Loader2 } from "lucide-react";
import { useLeadDetail } from "./lead-detail/useLeadDetail";
import { getStatusColor } from "./lead-detail/leadDetailModel";
import { LeadInfoPanel } from "./lead-detail/LeadInfoPanel";
import { ActivityTimeline } from "./lead-detail/ActivityTimeline";

const Header = ({ lead, status, isEditing, saving, onEdit, onSave, onClose }) => (
  <div className="bg-gradient-to-r from-[#00A38A]/20 to-[#00A38A]/20 border-b border-gray-800 px-6 py-4">
    <div className="flex items-center justify-between">
      <div className="flex items-center gap-4">
        <div className="w-12 h-12 rounded-full bg-gradient-to-r from-[#00A38A] to-[#00A38A] flex items-center justify-center"><Building2 className="h-6 w-6 text-white" /></div>
        <div>
          <h2 className="text-xl font-bold text-white" data-testid="lead-detail-company">{lead.companyName}</h2>
          <p className="text-gray-400 text-sm">{lead.industry}</p>
        </div>
        <Badge className={`${getStatusColor(status)} border ml-4`} data-testid="lead-detail-status">{status}</Badge>
      </div>
      <div className="flex items-center gap-2">
        {!isEditing ? (
          <Button variant="outline" size="sm" onClick={onEdit} className="border-gray-700 text-gray-300 hover:bg-white/10" data-testid="lead-edit-btn"><Edit3 className="h-4 w-4 mr-1" /> Edit</Button>
        ) : (
          <Button size="sm" onClick={onSave} disabled={saving} className="bg-[#00A38A] hover:bg-[#008570] text-white" data-testid="lead-save-btn">
            {saving ? <Loader2 className="h-4 w-4 animate-spin mr-1" /> : <Save className="h-4 w-4 mr-1" />} Save
          </Button>
        )}
        <button onClick={onClose} className="text-gray-400 hover:text-white transition-colors p-2" aria-label="Close" data-testid="lead-detail-close"><X className="h-6 w-6" /></button>
      </div>
    </div>
  </div>
);

const LeadDetailModal = ({ isOpen, onClose, lead, userId, onLeadUpdated }) => {
  const d = useLeadDetail({ isOpen, lead, userId, onLeadUpdated });
  if (!isOpen || !lead) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 backdrop-blur-sm" data-testid="lead-detail-modal">
      <div className="bg-gradient-to-br from-[#0f1419] to-[#1a1f24] rounded-2xl w-full max-w-4xl max-h-[90vh] overflow-hidden border border-gray-800 shadow-2xl">
        <Header lead={lead} status={d.editData.status || lead.status} isEditing={d.isEditing} saving={d.saving} onEdit={() => d.setIsEditing(true)} onSave={d.handleSave} onClose={onClose} />
        <div className="flex h-[calc(90vh-100px)]">
          <LeadInfoPanel lead={lead} editData={d.editData} isEditing={d.isEditing} setField={d.setField} />
          <ActivityTimeline d={d} />
        </div>
      </div>
    </div>
  );
};

export default LeadDetailModal;
